import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    records: [],
    loading: false
};

const dtrSlice = createSlice({
    name: "dtr",

    initialState,

    reducers: {}
});

export default dtrSlice.reducer;
